import { motiApiClient } from '@/lib/api/lib/client'
import type { V1MotiPayload } from '@/lib/api/lib/models/V1MotiPayload'
import { V1MotiActions } from '@/lib/api/lib/models/V1MotiActions'
import { getUserId } from '@/lib/cookies'

/**
 * Cheers someone training right now: an emoji (free), or an emoji with a
 * message (premium).
 */
export function sendCheer(
    to: string,
    emotion: string,
    message?: string
): Promise<void> {
    return motiApiClient.send({
        action: message ? V1MotiActions.EmotiMessage : V1MotiActions.Emoti,
        sendRequest: {
            count: 1,
            from: getUserId(),
            to,
            emotion,
            message
        } as V1MotiPayload
    })
}
